import { render, staticRenderFns } from "./cadveiculos.vue?vue&type=template&id=82a016e8&"
import script from "./cadveiculos.vue?vue&type=script&lang=js&"
export * from "./cadveiculos.vue?vue&type=script&lang=js&"
import style0 from "./cadveiculos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports